<div
  class="view-heading"
  [ngClass]="compact ? 'view-heading-compact' : 'view-heading-padded'"
>
  <div class="view-heading-section">
    <button
      *ngIf="viewName"
      class="view-tag p-button p-button-outlined p-button-rounded"
      disabled
    >
      {{ viewName }}
    </button>
  </div>
  <h2 *ngIf="viewTitle" class="view-heading-title primary-font">
    {{ viewTitle }}
  </h2>
  <p *ngIf="viewDescription" class="view-heading-description secondary-font">
    {{ viewDescription }}
  </p>
</div>
